import { getIndustryList } from "@/services/api/Master";
import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { ScrollArea } from "./ui/scroll-area";

function SelectIndustry({ isModal, value, onChange, disabled = false }) {
  const [industries, setIndustries] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const setCountry = async () => {
    if (industries.length == 0) {
      try {
        const response = await getIndustryList();
        const industryList = (response.data.data || []).sort((a, b) => {
          const aName = a.name.toLowerCase();
          const bName = b.name.toLowerCase();

          if (aName < bName) {
            return -1;
          }

          if (aName > bName) {
            return 1;
          }

          return 0;
        });
        setIndustries(industryList);
      } catch (error) {
        console.log("Error", error);
      }
    }
  };

  useEffect(() => {
    setCountry();
  }, []);

  return (
    <Select disabled={disabled} value={value} onValueChange={onChange}>
      <SelectTrigger
        className={
          isModal
            ? "bg-white text-background border-background/20 focus:ring-0"
            : "bg-white/5 hover:bg-white/10"
        }
      >
        <SelectValue placeholder='-- Select --' />
      </SelectTrigger>
      <SelectContent>
        <ScrollArea className='h-64'>
          {industries.map((industry) => (
            <SelectItem
              key={`select-industry-${industry.uuid}`}
              value={industry.name}
            >
              {industry.name}
            </SelectItem>
          ))}
        </ScrollArea>
      </SelectContent>
    </Select>
  );
}

SelectIndustry.defaultProps = {
  isModal: true,
};

export default SelectIndustry;
